import { PageRouteProps } from "../../types";

export const microServiceRoutes: PageRouteProps[] = [
  {
    pathName: "/microservice",
    module: ["Ecommerce"],
    component: "MicroServices",
    type: "public",
    mode: "static",
  },
  {
    pathName: "/microservice",
    module: ["Ecommerce"],
    component: "MicroServices",
    type: "public",
    mode: "dynamic",
  },
];
